/* Rarity inline-stars — safe version for titles */
(function () {
  /* ===== 0) 上の余白（テキスト＋☆ 行の “上” ） ===== */
  const GAP_ABOVE = '0.45em'; // 好みに変更可（em/px）

  /* ===== 1) スコア取得（未入力は 0。強制挿入はしない） ===== */
  const dataEl = document.getElementById('vn-rarity-data');
  let raw = dataEl ? (dataEl.getAttribute('data-score') || '').trim() : '';
  let SCORE = Number((raw || '0').replace(',', '.'));
  if (Number.isNaN(SCORE)) SCORE = 0;
  if (![0,0.5,1,1.5,2,2.5,3,3.5,4,4.5,5].includes(SCORE)) SCORE = 0;

  /* ===== 2) 対象範囲 ===== */
  const ROOT = document.getElementById('main') || document.querySelector('main');
  if (!ROOT) return;

  /* ===== 3) 必要なスタイルを注入 ===== */
  if (!document.getElementById('vn-rarity-style')) {
    const css = `
      .vn-inline-rarity{position:relative;display:inline-block;line-height:1;
        font-size:1em;letter-spacing:.12em;vertical-align:baseline}
      .vn-inline-rarity .vn-stars-base{color:#d9d9d9}
      .vn-inline-rarity .vn-stars-fill{position:absolute;left:0;top:0;white-space:nowrap;overflow:hidden;color:#4d4d4d}
    `;
    const st = document.createElement('style'); st.id = 'vn-rarity-style';
    st.appendChild(document.createTextNode(css)); document.head.appendChild(st);
  }

  /* ===== 4) ★DOM ===== */
  function makeStars(score) {
    const w = document.createElement('span');
    w.className = 'vn-inline-rarity';
    w.setAttribute('role','img');
    w.setAttribute('aria-label',`Rarity: ${score}/5`);
    const b = document.createElement('span'); b.className = 'vn-stars-base'; b.setAttribute('aria-hidden','true'); b.textContent = '★★★★★';
    const f = document.createElement('span'); f.className = 'vn-stars-fill'; f.setAttribute('aria-hidden','true');
    f.style.width = (score/5*100)+'%'; f.textContent = '★★★★★';
    w.append(b,f); return w;
  }

  /* ===== 5) 置換候補の作り方（整数単体は除外！） =====
     例：4 なら [ '4.0','4.00','4,0','4,00','4/5' ]
         3.5 なら [ '3.5','3,5','3.50','3,50','3.5/5', ... ]
  */
  function candidates(score){
    const n = String(score);
    let arr = [];
    if (n.indexOf('.') === -1) {
      // 整数は小数表記のみ採用（素の "4" は入れない）
      arr = [n+'.0', n+'.00', n.replace('.',',')+',0', n.replace('.',',')+',00', n+'/5'];
    } else {
      // 0.5 系
      const base = [n, n+'0', n.replace('.',','), n.replace('.',',')+'0'];
      const withDen = base.map(s => s + '/5');
      arr = base.concat(withDen);
    }
    // 長い候補を優先
    return Array.from(new Set(arr)).sort((a,b)=>b.length-a.length);
  }

  /* ===== 6) 余白とゴミノード掃除 ===== */
  const WS = /[\s\u00A0\u3000]+/g;
  const isWsText = n => n && n.nodeType===3 && !n.nodeValue.replace(WS,'');
  const onlyBrOrWs = el => el && el.nodeType===1 && Array.from(el.childNodes)
                         .every(c => (c.nodeName==='BR') || (c.nodeType===3 && !c.nodeValue.replace(WS,'')));
  const emptyBlock = el => el && el.nodeType===1 && /^(P|DIV|SPAN|SECTION|ARTICLE)$/i.test(el.nodeName) &&
                           (el.textContent.replace(WS,'')==='' || onlyBrOrWs(el));
  const emptyHeading = el => {
    if (!el || el.nodeType!==1) return false;
    if (/^(H1|H2|H3|H4|H5|H6)$/i.test(el.nodeName) && el.textContent.replace(WS,'')==='') return true;
    const cls = el.getAttribute('class')||'';
    return /(\s|^)h[1-6](\s|$)/i.test(cls) && el.textContent.replace(WS,'')==='';
  };
  const isHeading = el => {
    if (!el || el.nodeType!==1) return false;
    if (/^(H1|H2|H3|H4|H5|H6)$/i.test(el.nodeName)) return true;
    const cls = el.getAttribute('class')||'';
    if (/(\s|^)h[1-6](\s|$)/i.test(cls)) return true;
    return (el.nodeName==='P' && el.childNodes.length===1 && el.firstChild.nodeName==='STRONG');
  };
  function nearestRow(el){
    let up = el.parentNode, d=0;
    while (up && up!==ROOT && d<6) { if (up.nodeType===1 && /^(P|DIV|LI|DT|DD|SECTION|ARTICLE)$/i.test(up.nodeName)) return up; up=up.parentNode; d++; }
    return null;
  }
  function ancestor(el, cls){ let up=el; while(up && up!==ROOT){ if(up.nodeType===1 && up.classList && up.classList.contains(cls)) return up; up=up.parentNode; } return null; }
  function cleanProseHead(prose){
    let cur=prose.firstChild;
    while(cur){
      if (isWsText(cur) || (cur.nodeType===1 && (cur.nodeName==='BR'||onlyBrOrWs(cur)||emptyHeading(cur)||emptyBlock(cur)))){
        const nx=cur.nextSibling; cur.remove(); cur=nx; continue;
      } break;
    }
  }
  function removeEmptyPrevSiblings(prose){
    let sib = prose.previousSibling;
    while(sib){
      if (isWsText(sib) || (sib.nodeType===1 && (emptyHeading(sib)||emptyBlock(sib)||onlyBrOrWs(sib)))){
        const p=sib.previousSibling; sib.remove(); sib=p; continue;
      } break;
    }
  }
  function removeBreaksBefore(el){
    let n = el.previousSibling;
    while (n && n.nodeType===3 && n.nodeValue && n.nodeValue.replace(WS,'')!=='') n=n.previousSibling; // ラベル文字を飛ばす
    while (n){
      if (isWsText(n) || (n.nodeType===1 && (n.nodeName==='BR'||onlyBrOrWs(n)))) { const p=n.previousSibling; n.remove(); n=p; continue; }
      break;
    }
  }
  function tightenAround(starEl){
    removeBreaksBefore(starEl);
    const row = nearestRow(starEl);
    if (row){ row.style.marginTop = GAP_ABOVE; }
    if (row){
      let prev = row.previousElementSibling;
      if (prev && !isHeading(prev)) { let p=prev.previousElementSibling; while(p && !isHeading(p)) p=p.previousElementSibling; prev=p; }
      if (prev && isHeading(prev)) prev.style.marginBottom = '0';
    }
    const prose = ancestor(starEl,'prose');
    if (prose){ cleanProseHead(prose); removeEmptyPrevSiblings(prose); }
  }

  /* ===== 7) 数字→★ 置換（境界チェック強化） ===== */
  const isNumChar = ch => !!ch && /[0-9.,]/.test(ch);
  // 直前は数字/., でなければOK
  const okPrev = ch => ch==null || !isNumChar(ch);
  // 直後は数字/.,/ だけでなく ' ’ - − などでも NG（タイトルの 40's, -40's を防ぐ）
  const okNext = ch => ch==null || !/[0-9.,/'’\-−]/.test(ch);

  function replaceInTextNode(node, score, cands){
    const txt=node.nodeValue; let i=0, changed=false;
    const frag=document.createDocumentFragment();
    while (i < txt.length){
      let best=-1, tok=null;
      for (let k=0;k<cands.length;k++){
        const t=cands[k], idx=txt.indexOf(t,i);
        if (idx!==-1 && (best===-1||idx<best)){ best=idx; tok=t; if(idx===i) break; }
      }
      if (best===-1){ frag.appendChild(document.createTextNode(txt.slice(i))); break; }
      const prev = (best-1>=0)?txt[best-1]:null, next = (best+tok.length<txt.length)?txt[best+tok.length]:null;
      if (okPrev(prev) && okNext(next)){
        if (best>i) frag.appendChild(document.createTextNode(txt.slice(i,best)));
        const star = makeStars(score); frag.appendChild(star); i = best + tok.length; changed = true;
        requestAnimationFrame(()=> star.isConnected && tightenAround(star));
      } else {
        frag.appendChild(document.createTextNode(txt.slice(i,best+1))); i = best + 1;
      }
    }
    if (changed) node.parentNode.replaceChild(frag, node);
    return changed;
  }

  function run(){
    const cands = candidates(SCORE);
    const walker = document.createTreeWalker(ROOT, NodeFilter.SHOW_TEXT, {
      acceptNode(n){
        const t=n.nodeValue; if(!t || !t.trim()) return NodeFilter.FILTER_REJECT;
        const p=n.parentNode, tag=p && p.nodeName;
        if (!p || tag==='SCRIPT'||tag==='STYLE'||tag==='NOSCRIPT'||tag==='SVG') return NodeFilter.FILTER_REJECT;
        if (p.classList && p.classList.contains('vn-inline-rarity')) return NodeFilter.FILTER_REJECT;
        for (let i=0;i<cands.length;i++) if (t.indexOf(cands[i])!==-1) return NodeFilter.FILTER_ACCEPT;
        return NodeFilter.FILTER_REJECT;
      }
    });
    const nodes=[]; let cur; while(cur=walker.nextNode()) nodes.push(cur);
    nodes.forEach(n=>replaceInTextNode(n,SCORE,cands));
  }

  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', run); else run();
  try{
    let scheduled=false;
    new MutationObserver(muts=>{
      if (scheduled) return;
      if (!muts.some(m=>ROOT.contains(m.target))) return;
      scheduled=true; requestAnimationFrame(()=>{ scheduled=false; run(); });
    }).observe(ROOT,{childList:true,subtree:true});
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('shopify:section:select', run);
    document.addEventListener('shopify:section:unload', run);
  }catch(e){}
})();